module.exports = __webpack_public_path__ + "img/cook-islands.7c22a5cf.png";